import React, { useContext } from "react";
import { useRef, useState } from "react";
import ResetPasswordPage from "./ResetPasswordPage";
import { toast } from "../../utils/toast";
import { checkOtp } from "../../service/AuthService";
import AppContext from "../../context/AppContext";
import CommonButton from "../../components/common/CommonButton";

const getBackendErrorMessage = (error) =>
  error?.response?.data?.body?.value ??
  error?.response?.data?.body?.error ??
  error?.response?.data?.message ??
  error?.body?.value ??
  error?.body?.error ??
  error?.message;

const OtpVerification = ({ emaill }) => {
  const [resetEmail, setResetEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const inputOne = useRef(null);
  const inputTwo = useRef(null);
  const inputThree = useRef(null);
  const inputFour = useRef(null);
  const { theme } = useContext(AppContext);
  const inputChangeHandler = (event, nextInput) => {
    if (event.target.value.length === 1 && nextInput) {
      nextInput.current.focus();
    }
  };

  async function onSubmit(event) {
    try {
      event.preventDefault();
      setLoading(true);
      const otp_1 = inputOne.current.value;
      const otp_2 = inputTwo.current.value;
      const otp_3 = inputThree.current.value;
      const otp_4 = inputFour.current.value;
      const otp = `${otp_1}${otp_2}${otp_3}${otp_4}`;
      const responseData = await checkOtp(otp, emaill);
      if (responseData.header.code === 600) {
        toast.success("OTP correct");
        setLoading(false);
        setResetEmail(emaill);
      } else {
        toast.error(responseData.body.value);
      }
    } catch (error) {
      console.error("Error:", error);
      const backendMessage = getBackendErrorMessage(error);
      if (backendMessage) {
        toast.error(backendMessage);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      {!resetEmail && (
        <div
          className="flex justify-center items-center min-h-[100dvh] overflow-y-auto px-4 py-6 sm:p-8"
          style={{
            background: "radial-gradient(#1E429F33, #FFFFFF)",
          }}
        >
          <div className="w-1/2 hidden lg:block h-full max-h-[850px]">
            <img
              src="https://res.cloudinary.com/dpdvpazfv/image/upload/v1753344908/loginImage_qiuxl2.png"
              alt="OTP Verification"
              className="object-fill w-full max-w-[882px] h-full rounded-[31px]"
            />
          </div>
          <div className="px-4 py-8 sm:px-8 md:px-12 lg:px-16 w-full lg:w-1/2 max-w-xl text-center">
            <h1 className="text-sm text-blue-800 mb-4">
              We have sent you{" "}
              <span className="font-bold">One Time Password</span> to your email
            </h1>
            <p className="text-sm text-gray-500 font-semibold">
              Please Enter OTP
            </p>
            <div className="mt-8 sm:mt-10">
              <form onSubmit={onSubmit}>
                <div className="flex flex-col space-y-10 sm:space-y-16">
                  <div className="flex flex-row items-center justify-between mx-auto w-full max-w-[280px] sm:max-w-xs gap-2 sm:gap-3">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 shrink-0">
                      <input
                        className={`w-full h-full flex flex-col items-center justify-center text-center px-2 outline-none border-b-2
                         border-gray-400 text-lg sm:text-xl font-bold bg-white rounded-md ${
                           theme === "dark"
                             ? "text-black"
                             : theme === "high-contrast"
                             ? "text-black"
                             : ""
                         }`}
                        type="text"
                        name="inputOne"
                        id="inputOne"
                        maxLength={1}
                        ref={inputOne}
                        onChange={(e) => inputChangeHandler(e, inputTwo)}
                      />
                    </div>
                    <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 shrink-0">
                      <input
                        className={`w-full h-full flex flex-col items-center justify-center text-center px-2 outline-none border-b-2
                         border-gray-400 text-lg sm:text-xl font-bold bg-white rounded-md ${
                           theme === "dark"
                             ? "text-black"
                             : theme === "high-contrast"
                             ? "text-black"
                             : ""
                         }`}
                        type="text"
                        name="inputTwo"
                        id="inputTwo"
                        maxLength={1}
                        ref={inputTwo}
                        onChange={(e) => inputChangeHandler(e, inputThree)}
                      />
                    </div>
                    <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 shrink-0">
                      <input
                        className={`w-full h-full flex flex-col items-center justify-center text-center px-2 outline-none border-b-2
                         border-gray-400 text-lg sm:text-xl font-bold bg-white rounded-md ${
                           theme === "dark"
                             ? "text-black"
                             : theme === "high-contrast"
                             ? "text-black"
                             : ""
                         }`}
                        type="text"
                        name="inputThree"
                        id="inputThree"
                        maxLength={1}
                        ref={inputThree}
                        onChange={(e) => inputChangeHandler(e, inputFour)}
                      />
                    </div>
                    <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 shrink-0">
                      <input
                        className={`w-full h-full flex flex-col items-center justify-center text-center px-2 outline-none
                         border-b-2 border-gray-400 text-lg sm:text-xl font-bold bg-white rounded-md ${
                           theme === "dark"
                             ? "text-black"
                             : theme === "high-contrast"
                             ? "text-black"
                             : ""
                         }`}
                        type="text"
                        name="inputFour"
                        id="inputFour"
                        maxLength={1}
                        ref={inputFour}
                        onChange={(e) => inputChangeHandler(e)}
                      />
                    </div>
                  </div>
                  <div className="flex flex-row justify-center gap-4 sm:gap-6 flex-wrap">
                    <CommonButton colorIntent="primary"
                      type="button"
                      variant="outline"
                      className="!rounded-[10px] !uppercase !text-xs !border-[#236DB4] !text-[#236DB4]"
                      data-ripple-light="true"
                    >
                      Resend OTP
                    </CommonButton>
                    <CommonButton colorIntent="primary"
                      type="submit"
                      variant="primary"
                      disabled={loading}
                      className="!rounded-[10px] !uppercase !text-xs"
                      data-ripple-light="true"
                    >
                      {loading ? "Verifying..." : "Verify OTP"}
                    </CommonButton>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {resetEmail && <ResetPasswordPage emaill={resetEmail} />}
    </div>
  );
};

export default OtpVerification;
